import { cn, getStatusColor } from '../lib/utils';
import { Check, Clock, AlertCircle, Pause } from 'lucide-react';

export function StatusBadge({ status, lane, className }) {
  const colors = getStatusColor(status);
  
  const getIcon = () => {
    if (!status) return <Pause className="w-3 h-3" />;
    const statusLower = status.toLowerCase();
    
    if (statusLower.includes('completed') || statusLower.includes('complete') || statusLower.includes('ready')) {
      return <Check className="w-3 h-3" />;
    }
    if (statusLower.includes('progress')) {
      return <Clock className="w-3 h-3" />;
    }
    if (statusLower.includes('failed') || statusLower.includes('error')) {
      return <AlertCircle className="w-3 h-3" />;
    }
    return <Pause className="w-3 h-3" />;
  };

  const formatStatus = (status) => {
    if (!status) return 'Pending';
    return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <span
      data-testid={`status-badge-${lane || 'default'}`}
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border',
        colors.bg,
        colors.text,
        colors.border,
        className
      )}
    >
      {getIcon()}
      {formatStatus(status)}
    </span>
  );
}
